import { tr } from 'mmfintech-commons'
import { MMButton } from '@components'

export const NewsButtonsContainer = ({ activeNewsIndex, availableNewsLength, handleTransition }) => (
  <div className='buttons-container'>
    {(activeNewsIndex > 0 || true) && (
      <MMButton
        type='button'
        size='large'
        variant='secondary'
        caption={tr('FRONTEND.NEWS_BUTTONS_CONTAINER.PREVIOUS', 'Previous')}
        onClick={() => handleTransition(activeNewsIndex - 1)}
        aria-label={tr('FRONTEND.NEWS_BUTTONS_CONTAINER.GO_TO_PREVIOUS_NEWS', 'Go to previous news')}
        data-test='previous-button'
      />
    )}
    <MMButton
      type='button'
      size='large'
      variant='primary'
      caption={
        activeNewsIndex === availableNewsLength - 1
          ? tr('FRONTEND.NEWS_BUTTONS_CONTAINER.GOT_IT', 'Got it!')
          : tr('FRONTEND.CUSTOMERS.EDIT.BUTTON_NEXT', 'Next')
      }
      onClick={() => handleTransition(activeNewsIndex + 1)}
      aria-label={tr('FRONTEND.NEWS_BUTTONS_CONTAINER.GO_TO_NEXT_NEWS', 'Go to next news')}
      data-test='next-button'
    />
  </div>
)
